import { Stack } from '@mui/material';
import Button from 'domains/core/components/Button';
import Interaction from './Interaction';
import { VoiceContentInteraction } from '../types';
import { actionTypes } from '../voiceCallActions';

const maxInteractionCount = 11;

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    interactions: VoiceContentInteraction[];
};

const Interactions = ({ dispatchVoiceContentAction: dispatch, interactions }: Props) => {
    const selectedKeypadOptionsList = interactions.map((interaction) => interaction.keypadOption);

    return (
        <Stack direction="column" mb={2} rowGap={2}>
            {interactions.map((interaction, index) => (
                <Interaction
                    key={interaction.keypadOption + index}
                    dispatchVoiceContentAction={dispatch}
                    index={index}
                    interaction={interaction}
                    selectedKeypadOptions={selectedKeypadOptionsList}
                />
            ))}
            {interactions.length < maxInteractionCount && (
                <Button
                    variant="contained"
                    sx={{ alignSelf: 'flex-start' }}
                    onClick={() => dispatch({ type: actionTypes.ADD_INTERACTION })}
                >
                    Add an Interaction
                </Button>
            )}
        </Stack>
    );
};

export default Interactions;
